import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatSnackBar} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';


import { CetresService } from '../_services'
import { PartidaCetresService } from '../_services'
import { PagoConsignanteService } from '../_services'



/**
 * @title Table retrieving data through HTTP
 */
@Component({
  selector: 'app-cetres',
  templateUrl: './cetres.component.html',
  styleUrls: ['./cetres.component.scss']
})



export class CetresComponent implements AfterViewInit {
  displayedColumns: string[] = ['created', 'consignor_name', 'description', 'code', 
  'monto_base', 'iva', 'saldo_antes', 'variacion_saldo', 'saldo_despues', 
  'iva_antes', 'iva_despues'];
  cetresDatabase: CetresDatabase | null;
  data: CetresIssue[] = [];
  coins;
  la_fecha_corte;
  cetresForm: FormGroup;
  partidaForm: FormGroup;
  pagoForm: FormGroup;
  form_cetres: []
  cetres: any = {};
  partidas_cetres: any = {};
  pago_consignante: any = {};


  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(
          private formBuilder: FormBuilder,
          private cetresService: CetresService,
          private partidas_cetresService: PartidaCetresService,
          private pago_consignanteService: PagoConsignanteService,
          private _httpClient: HttpClient, 
          private _hs: HttpService,
          private snackBar: MatSnackBar,
    ) { }


  ngOnInit() {
    this.cetresForm = this.formBuilder.group({
      ceduno_id: ['', Validators.required],
      inicio_corte: ['', Validators.required],
      fin_corte: ['', Validators.required],
      total_recibido_bancos: ['', Validators.required],
      total_egresos: ['', Validators.required],
      total_consignante: ['', Validators.required],
      spa_revolvente: ['', Validators.required],
      spa_factura_imp: ['', Validators.required],
      spa_ganancia_estimada: ['', Validators.required],
      pr_revolvente: ['', Validators.required],
      pr_factura_imp: ['', Validators.required],
      pr_ganancia_estimada: ['', Validators.required],
      sa_revolvente: ['', Validators.required],
      sa_factura_imp: ['', Validators.required],
      sa_ganancia_estimada: ['', Validators.required],
      inventario_piso: ['', Validators.required],
      por_retornar_consignante: ['', Validators.required],
    });


    this.partidaForm = this.formBuilder.group({
      cetres_id: ['', Validators.required],
      descripcion: ['', Validators.required],
      monto_con_iva: ['', Validators.required],
    });

    this.pagoForm = this.formBuilder.group({
      cetres_id: ['', Validators.required],
      banco_emisor: ['', Validators.required],
      intermediario: ['', Validators.required],
      fecha: ['', Validators.required],
      monto: ['', Validators.required],
      banco_receptor: ['', Validators.required],
      concepto: ['', Validators.required],
    });

     
  }


  onSubmitPago() {
    console.log("submitted el form partida_cetres")
    this.pago_consignante["cetres_id"] = this.pagoForm.value.cetres_id
    this.pago_consignante["banco_emisor"] = this.pagoForm.value.banco_emisor
    this.pago_consignante["intermediario"] = this.pagoForm.value.intermediario
    this.pago_consignante["fecha"] = this.pagoForm.value.fecha
    this.pago_consignante["monto"] = this.pagoForm.value.monto
    this.pago_consignante["banco_receptor"] = this.pagoForm.value.banco_receptor
    this.pago_consignante["concepto"] = this.pagoForm.value.concepto

    console.log(this.pago_consignante)
     this.pago_consignanteService.registrar(this.pago_consignante)
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   console.log("guardado recibido en component")
                   console.log("la data es")
                   console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Partida Cetres guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    console.log("error recibido en component")
                });
  }

  onSubmitPtres() {
    console.log("submitted el form partida_cetres")
    this.partidas_cetres["cetres_id"] = this.partidaForm.value.cetres_id
    this.partidas_cetres["descripcion"] = this.partidaForm.value.descripcion
    this.partidas_cetres["monto_con_iva"] = this.partidaForm.value.monto_con_iva

    console.log(this.partidas_cetres)
     this.partidas_cetresService.registrar(this.partidas_cetres)
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   console.log("guardado recibido en component")
                   console.log("la data es")
                   console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Partida Cetres guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    console.log("error recibido en component")
                });
  }

  onSubmit() {
    console.log("submitted el form cetres")
    console.log(this.cetresForm.value.razon)
    // hacer un servicio e invocarlo
    
    this.cetres["ceduno_id"] = this.cetresForm.value.ceduno_id
    this.cetres["inicio_corte"] = this.cetresForm.value.inicio_corte
    this.cetres["fin_corte"] = this.cetresForm.value.fin_corte
    this.cetres["total_recibido_bancos"] = this.cetresForm.value.total_recibido_bancos
    this.cetres["total_egresos"] = this.cetresForm.value.total_egresos
    this.cetres["total_consignante"] = this.cetresForm.value.total_consignante
    this.cetres["spa_revolvente"] = this.cetresForm.value.spa_revolvente
    this.cetres["spa_factura_imp"] = this.cetresForm.value.spa_factura_imp
    this.cetres["spa_ganancia_estimada"] = this.cetresForm.value.spa_ganancia_estimada
    this.cetres["pr_revolvente"] = this.cetresForm.value.pr_revolvente
    this.cetres["pr_factura_imp"] = this.cetresForm.value.pr_factura_imp
    this.cetres["pr_ganancia_estimada"] = this.cetresForm.value.pr_ganacia_estimada
    this.cetres["sa_revolvente"] = this.cetresForm.value.sa_revolvente
    this.cetres["sa_factura_imp"] = this.cetresForm.value.sa_factura_imp
    this.cetres["sa_ganancia_estimada"] = this.cetresForm.value.sa_ganancia_estimada
    this.cetres["inventario_piso"] = this.cetresForm.value.inventario_piso
    this.cetres["por_retornar_consignante"] = this.cetresForm.value.por_retornar_consignante

    console.log("la cetres es ")
    console.log(this.cetres)
     this.cetresService.registrar(this.cetres)
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   console.log("guardado recibido en component")
                   console.log("la data es")
                   console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Cetres guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    console.log("error recibido en component")
                });
  }


  ngAfterViewInit() {

    this.cetresDatabase = new CetresDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.cetresDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          console.log("vamos en la 72")
          console.log(data)

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  


  }

  setClasses(fecha_creado) {
    let hoy = new Date();
    let fecha_pago = new Date(fecha_creado);

    let fecha_corte = new Date(this.coins);


   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }




}



export interface CetresApi {
  items: CetresIssue[];
  total_count: number;
}

export interface CetresIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class CetresDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<CetresApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_cetres.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<CetresApi>(requestUrl);
  }
}
